$('.categories-container .categories .photos a').on('click', function(e){
    e.preventDefault();
    $('.category-tab').fadeOut(500);
    $('.category-tab[data-tab-key="'+$(this).attr('data-tab-key')+'"]').fadeIn(500);
});

$('.category-tab .left .subcategories li a').on('click', function(e){
    e.preventDefault();
    $(this).closest('.category-tab').find('.subcategories .active').removeClass('active');
    $(this).addClass('active');
    $(this).closest('li').addClass('active');
    $(this).closest('.category-tab').find('.right.active').removeClass('active');
    $(this).closest('.category-tab').find('.right[data-cat-slug="'+$(this).attr('data-cat-slug')+'"]').addClass('active');
    // $('.category-tab[data-tab-key="'+$(this).attr('data-tab-key')+'"]').fadeIn(500);
});

if($(window).width() < 992){
    $('.subcategories li').on('click', function(){
       $(this).closest('.subcategories').find('li:not(.selected-item)').slideToggle(500);
       $(this).closest('.subcategories').toggleClass('open');
       $(this).closest('.subcategories').find('.selected-item').html($(this).find('a').html());
    });
}